



































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import QuickSnack from "@/components/QuickSnack.vue";
import { deleteTopayMessage, queryTopayMessages } from "@/domain/backend/vending";
import { logError } from "@/util";
import { ExtraData, VendingConfigOptions, VendingTerminalResponse } from "@/domain/api";

@Component({
  components: { QuickSnack }
})
export default class VendingTopayMessages extends Vue {
  @Prop() vendingOptions!: VendingConfigOptions | null;
  @Prop() config!: VendingTerminalResponse | null;
  showTopayMessages = false;
  topayMessagesPage = 0;
  dialogExtraData = false;
  topayExtraData: ExtraData | null = null;
  topayExtraDataKeys: string[] | null = null;

  get lang() {
    return this.$store.state.lang.data;
  }

  get snackbar() {
    return this.$refs.snackbar as QuickSnack;
  }

  get tcod() {
    return this.config?.TCOD;
  }

  setVisible(show: boolean) {
    this.showTopayMessages = show;
  }

  @Watch("config")
  onConfigChanged() {
    this.topayMessagesPage = 0;
    this.setVisible(false);
  }

  async loadMoreMessages() {
    try {
      if (!this.tcod) throw new Error("Invalid tcod");
      if (!this.config) throw new Error("Invalid vending configuration");
      const result = await queryTopayMessages(this.tcod, this.topayMessagesPage + 1);
      const currentMessages = this.config.topayMessages ?? [];
      for (const msg of result.topayMessages) {
        currentMessages.push(msg);
      }
      this.config.topayMessages = currentMessages;
      this.topayMessagesPage = result.page;
    } catch (ex) {
      logError("Error saving terminal", { ex });
      this.snackbar.show(this.lang.errorLoadingData + ": " + (ex as Error).message, "error");
    }
  }

  async deleteTopayMessage(id: string) {
    try {
      if (!this.tcod) {
        this.snackbar.show("Invalid TCOD", "error");
        return;
      }
      const res = await deleteTopayMessage(id, this.tcod);
      if (res.saved) {
        this.snackbar.show(this.lang.toPayMessageDeleted, "success"); //
        this.$emit("refresh-terminal", {});
      } else {
        this.snackbar.show("Error: " + res.message, "error");
      }
    } catch (err) {
      logError("Error deleting topay message", { err });
      this.snackbar.show(this.lang.errorSaving + (err as Error).message, "error");
    }
  }

  showExtraData(extraData: ExtraData) {
    this.topayExtraData = extraData || null;
    if (this.topayExtraData) {
      this.topayExtraDataKeys = Object.keys(this.topayExtraData);
      this.dialogExtraData = true;
    }
  }

  topayMessageType(type: string): string {
    return this.vendingOptions?.topayOptions?.messageTypes[type] ?? type;
  }

  timestamp(timestamp: number): string {
    return new Date(timestamp).toLocaleString();
  }
}
